module.exports = __webpack_public_path__ + "static/media/Burlingame.015ca82b.jpg";